import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Connects to data-controller="leave-nudge"
// Provides interactive leave density feedback when staff select dates
// for time-off requests.
export default class extends Controller {
  static targets = ["startDate"]
  static values = { url: String }

  connect() {
    this._debounce = null
  }

  disconnect() {
    clearTimeout(this._debounce)
  }

  checkDensity() {
    const date = this.startDateTarget.value
    if (!date) return

    clearTimeout(this._debounce)
    this._debounce = setTimeout(() => {
      this._fetchDensity(date)
    }, 300)
  }

  selectDate(event) {
    event.preventDefault()
    const newDate = event.currentTarget.dataset.date
    if (!newDate) return

    this.startDateTarget.value = newDate
    this._fetchDensity(newDate)
  }

  _fetchDensity(date) {
    const url = `${this.urlValue}?date=${encodeURIComponent(date)}`
    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      }
    })
      .then(response => {
        if (response.ok) return response.text()
        return ""
      })
      .then(html => {
        if (html) Turbo.renderStreamMessage(html)
      })
  }
}
